import {PageLayout} from './layout';

var init = new PageLayout();
init.run();